import React, { useState, useEffect } from "react";
import DataService from "../../../../../Service";
import SLA from "../../../Organization/ManageInfo/AssignmentSummary/SLA";
import {
  Box,
  Divider,
  DialogTitle,
  Typography,
  Tooltip,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import Button from "@material-ui/core/Button";
import MaterialTable from "material-table";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import SLAModal from "../../Setup/SLA/SLAModal";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import MetricDrawer from "../OrgansationalMetric/metricDrawer";
import OrganisationDrawer from "./OrganisationDrawer";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import { useDispatch } from "react-redux";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";
import SearchIcon from "@material-ui/icons/Search";
import { Autocomplete } from "@material-ui/lab";
import SetupAutoComplete from "../SetupAutoComplete";

let useStyles: any;
useStyles = makeStyles((theme) => ({
  buttonShadow: {
    textTransform: "inherit",
  },
  tooltipMaxWidth: {
    maxWidth: "450px",
  },
  tooltipMinWidth: {
    maxWidth: "300px",
  },
  formWrapper: {
    background: "#fff",
    width: "400px",
    padding: theme.spacing(3),
  },
  dialog_title: {
    "& h6": {
      fontWeight: "700",
    },
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "center",
    "& button": {
      marginRight: "20px",
    },
  },
  miTablebox: {
    "& .MuiFormControl-root": {
      width: "25%",
    },
  },
}));

const SLAModule: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [SLAData, setSLAData] = useState<[]>([]);
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(20);
  const [totalCount, setTotalCount] = useState<number>(100);
  const [currentSelection, setCurrentSelection] = useState<any>({});
  const [modal, setModal] = useState<string>("");
  const [drawer, setDrawer] = useState<boolean>(false);
  const [confirmModalFlag, setConfirmModalFlag] = useState<boolean>(false);
  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    fetchSLA();
  }, [pageSize, page, searchText]);

  const fetchSLA = () => {
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
      search_keyword: searchText,
    };
    DataService.getData(params, "fetch_SLA")
      .then((res) => {
        if (res?.["success"]) {
          setSLAData(res?.["SLA"]);
          setTotalCount(res?.total_count);
        }
      })
      .catch((error) => {});
  };

  const confirmModal = () => {
    return (
      <Dialog
        maxWidth={"sm"}
        style={{ height: "70%" }}
        open={confirmModalFlag}
        fullWidth={false}
        onClose={() => {
          setConfirmModalFlag(false);
        }}
      >
        <DialogTitle
          id="customized-dialog-title"
          className={classes.dialog_title}
        ></DialogTitle>
        <DialogContent style={{ margin: "0px auto" }}>
          <div className={classes.formWrapper}>
            <Typography variant="h2">
              Warning, Deleting this module will delete both the module and
              their items from the ordering list. Are you sure?
            </Typography>
            <div className={classes.actionButtons}>
              <Button
                disableElevation
                type="button"
                onClick={() => {
                  setConfirmModalFlag(false);
                }}
                variant={"contained"}
                style={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                disableElevation
                type="submit"
                variant={"contained"}
                onClick={handleDelete}
                color="secondary"
                style={{ textTransform: "none" }}
              >
                Yes, Confirm
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  };

  const handleDelete = () => {
    DataService.deleteDirectFeild(
      `slas/delete_SLA?SLA_id=${currentSelection?.id}`
    )
      .then((res) => {
        dispatch(showSnackbar("success", [res?.message], 5000));
        setConfirmModalFlag(false);
        setCurrentSelection({});
        fetchSLA();
      })
      .catch((error) => {
        setConfirmModalFlag(true);
      });
  };

  const descValues = SLAData.map((el: any) => el.description);
  const measureValues = SLAData.map((el: any) => el.measure);
  const dropdownValues = descValues.concat(measureValues);
  // const uniqueArray = [
  //   ...(new Set(dropdownValues.filter((value) => value !== null)) as any),
  // ];
  const searchSelectHandler = (option: any) => {
    setSearchText(option);
    setPage(0);
  };
  return (
    <>
      <Box mb={3} className={classes.miTablebox}>
        <SetupAutoComplete
          type={"sla"}
          searchSelectHandler={searchSelectHandler}
        />
        <MaterialTable
          title=""
          options={{
            search: false,
            actionsColumnIndex: -1,
            searchFieldAlignment: "left",
            pageSize: pageSize,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 700,
              color: "#077F83",
              position: "sticky",
              top: "0",
            },
            maxBodyHeight: "600px",
            pageSizeOptions: [20, 50, 75, 100],
          }}
          columns={[
            {
              title: "Description",
              field: "description",
              type: "string",
              emptyValue: "-",
              customSort: (a: any, b: any) => {
                const nameA = a.description.toLowerCase();
                const nameB = b.description.toLowerCase();

                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0;
              },
            },

            {
              title: "Measure",
              field: "measure",
              type: "string",
              emptyValue: "-",
              customSort: (a: any, b: any) => {
                const nameA = a.measure.toLowerCase();
                const nameB = b.measure.toLowerCase();

                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0;
              },
            },
          ]}
          data={SLAData}
          totalCount={totalCount}
          page={page}
          onRowClick={(e, rowData) => {
            setCurrentSelection(rowData);
          }}
          onChangePage={(page) => {
            setPage(page);
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onSearchChange={(search) => {
            // setSearchText(search);
          }}
          actions={[
            {
              icon: () => (
                <Tooltip
                  title={<TooltipWrapper text="Edit" />}
                  children={<EditIcon fontSize="small" />}
                />
              ),

              onClick: (event, rowData) => {
                setModal("updateSLA");
                setCurrentSelection(rowData);
              },
            },
            {
              icon: () => (
                <Tooltip
                  title={<TooltipWrapper text="View" />}
                  children={<VisibilityIcon fontSize="small" />}
                />
              ),

              onClick: (event, rowData) => {
                setDrawer(true);
                setCurrentSelection(rowData);
                window.document.getElementById("root")?.scrollIntoView(true);
              },
            },
            {
              icon: () => (
                <Tooltip
                  title={<TooltipWrapper text="Delete" />}
                  children={<DeleteIcon fontSize="small" />}
                />
              ),

              onClick: (event, rowData) => {
                setCurrentSelection(rowData);
                setConfirmModalFlag(true);
              },
            },
            {
              icon: () => (
                <Button
                  className={classes.buttonShadow}
                  variant="contained"
                  color="secondary"
                >
                  + Setup a new SLA
                </Button>
              ),
              isFreeAction: true,
              onClick: (event) => {
                setModal("createSLA");
                setCurrentSelection({});
              },
            },
          ]}
        />

        {modal == "createSLA" ? (
          <SLAModal
            isOpen={modal}
            fetchSLA={fetchSLA}
            currentSelection={currentSelection}
            onClose={() => {
              setModal("");
            }}
          />
        ) : (
          <SLAModal
            isOpen={modal}
            fetchSLA={fetchSLA}
            currentSelection={currentSelection}
            onClose={() => {
              setModal("");
            }}
          />
        )}
        {confirmModalFlag && confirmModal()}
        {drawer && (
          <OrganisationDrawer
            parentCall={setDrawer}
            currentSelection={currentSelection}
          />
        )}
      </Box>
    </>
  );
};

export default SLAModule;
